import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface OfflinePaymentDialogData {
  orderTitle: string;
  cartItems: any[];
  totals: { subtotal: number; tax: number; tip: number; total: number };
  paymentMethod: 'card' | 'cash';
  businessName: string;
}

export interface OfflinePaymentDialogResult {
  confirmed: true;
}

@Component({
  selector: 'app-offline-payment-dialog',
  templateUrl: './offline-payment-dialog.component.html',
  styleUrls: ['./offline-payment-dialog.component.scss'],
})
export class OfflinePaymentDialogComponent implements OnInit {

  confirming = false;

  constructor(
    public dialogRef: MatDialogRef<OfflinePaymentDialogComponent, OfflinePaymentDialogResult | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: OfflinePaymentDialogData,
  ) {}

  ngOnInit(): void {}

  formatCents(cents: number): string {
    return '$' + (cents / 100).toFixed(2);
  }

  getItemDisplayName(item: any): string {
    return item?.name || item?.item?.name || 'Item';
  }

  getItemPrice(item: any): number {
    return item?.price || item?.priceWithModifiers || item?.unitCost || 0;
  }

  getItemQty(item: any): number {
    return item?.quantity || 1;
  }

  cancel(): void {
    this.dialogRef.close(undefined);
  }

  confirm(): void {
    if (this.confirming) { return; }
    this.confirming = true;
    // Brief loading state to prevent accidental double-tap
    setTimeout(() => {
      this.dialogRef.close({confirmed: true});
    }, 1000);
  }
}
